"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumType = void 0;
var EnumType;
(function (EnumType) {
    /** 国内海外区分 */
    EnumType["BILLED_FROM"] = "billedFrom";
})(EnumType = exports.EnumType || (exports.EnumType = {}));
